import classnames from 'classnames';
import React from 'react';
import { AdSlot, DFPSlotsProvider } from 'react-dfp';

import { AD_UNIT_PREFIX, DFP_NETWORK_ID, DIV_PREFIX } from 'src/app/constants/ad';
import { EventData } from 'src/app/models/ad';

interface MyProps {
  adUnitName: string;
  hostname: string;
  position: string;
  sizeMapping: Array<{
    sizes: number[][];
    viewport: number[];
  }>;
  sizes: number[][];
  shouldRefreshAd: () => boolean;
  category?: string[];
  className?: string;
  program?: string;
  video?: string;
}

interface MyState {
  isAdRendered: boolean;
}

export class AdContent extends React.Component<MyProps, MyState> {
  constructor(props: MyProps) {
    super(props);

    this.state = {
      isAdRendered: false
    };
    this.onSlotRender = this.onSlotRender.bind(this);
  }

  render(): JSX.Element {
    const { adUnitName, category, className, hostname, position, program, shouldRefreshAd, sizeMapping, sizes, video } = this.props;
    return (
      <div className={classnames(this.state.isAdRendered && className)}>
        <DFPSlotsProvider
          dfpNetworkId={DFP_NETWORK_ID}
          targetingArguments={{ position: [position], category, program, hostname, video }}
          sizeMapping={sizeMapping}
          collapseEmptyDivs={true}
        >
          <AdSlot
            adUnit={`${AD_UNIT_PREFIX}/${adUnitName}/${position}`}
            onSlotRender={this.onSlotRender}
            shouldRefresh={shouldRefreshAd}
            sizes={sizes}
            slotId={DIV_PREFIX + position}
          />
        </DFPSlotsProvider>
      </div>
    );
  }

  private onSlotRender(eventData: EventData): void {
    if (!eventData.event.isEmpty && !this.state.isAdRendered) {
      this.setState({ isAdRendered: true });
    }
  }
}
